import type { JSX } from 'react';

interface Props {
    className?: string;
    size?: string | number;
    color?: string;
}

export const CustomCancelCircleSolid = ({ className, size, color = '#FF4D6A' }: Props): JSX.Element => {
    const sizeStyle = typeof size === 'number' ? `${size}px` : size;
    return (
        <svg
            viewBox="0 0 13.3333 13.3333"
            className={className}
            style={{
                width: sizeStyle || 'inherit',
                height: sizeStyle || 'inherit',
                display: 'flex',
                overflow: 'visible',
                verticalAlign: 'middle',
            }}
            fill="none"
        >
            <path
                d="M4.26667 10L6.66667 7.6L9.06667 10L10 9.06667L7.6 6.66667L10 4.26667L9.06667 3.33333L6.66667 5.73333L4.26667 3.33333L3.33333 4.26667L5.73333 6.66667L3.33333 9.06667L4.26667 10ZM6.66667 13.3333C5.74444 13.3333 4.87778 13.1583 4.06667 12.8083C3.25556 12.4583 2.55 11.9833 1.95 11.3833C1.35 10.7833 0.875 10.0778 0.525 9.26667C0.175 8.45556 0 7.58889 0 6.66667C0 5.74444 0.175 4.87778 0.525 4.06667C0.875 3.25556 1.35 2.55 1.95 1.95C2.55 1.35 3.25556 0.875 4.06667 0.525C4.87778 0.175 5.74444 0 6.66667 0C7.58889 0 8.45556 0.175 9.26667 0.525C10.0778 0.875 10.7833 1.35 11.3833 1.95C11.9833 2.55 12.4583 3.25556 12.8083 4.06667C13.1583 4.87778 13.3333 5.74444 13.3333 6.66667C13.3333 7.58889 13.1583 8.45556 12.8083 9.26667C12.4583 10.0778 11.9833 10.7833 11.3833 11.3833C10.7833 11.9833 10.0778 12.4583 9.26667 12.8083C8.45556 13.1583 7.58889 13.3333 6.66667 13.3333ZM6.66667 12C8.15556 12 9.41667 11.4833 10.45 10.45C11.4833 9.41667 12 8.15556 12 6.66667C12 5.17778 11.4833 3.91667 10.45 2.88333C9.41667 1.85 8.15556 1.33333 6.66667 1.33333C5.17778 1.33333 3.91667 1.85 2.88333 2.88333C1.85 3.91667 1.33333 5.17778 1.33333 6.66667C1.33333 8.15556 1.85 9.41667 2.88333 10.45C3.91667 11.4833 5.17778 12 6.66667 12Z"
                fill={color}
            />
        </svg>
    );
};
